import firebase from 'firebase/app';
import { store } from '../../store';

 /** main.ts Decorator */
export default () => {
  console.log('main.ts init with firestore')
  firebase.auth().onAuthStateChanged(async (user) => {
    store.commit('usersModule/setIsNewUser');
    if (user) {
      store.dispatch('usersModule/onAuthStateChanged', { user, isNewUser: false });
    }
  });
}
